import type { Address } from '@models/address.model';

export function formatFullAddress({
  city = '',
  number = '',
  postcode = '',
  street = '',
}: Partial<Omit<Address, 'id'>>) {
  const streetPart = [street.trim(), number.trim()].filter(Boolean).join(' ');
  const cityPart = [postcode.trim(), city.trim()].filter(Boolean).join(' ');
  return [streetPart, cityPart].filter(Boolean).join(', ');
}
